import { Alert, Breadcrumb, Button, Card, Col, Icon, message, Popconfirm, Row, Tabs, Tag, Tooltip } from 'antd'
import Email from '../../../../api/Email'
import { EnquiriesApi } from '../../../../api/Sales/Enquiries'
import { DeliveryOrderApi } from '../../../../api/Purchase/DeliveryOrder'
import { OrdersApi as PurchaseOrdersApi } from '../../../../api/Purchase/Orders'
import OrdersApi from '../../../../api/Sales/Orders'
import Templates from '../../../../api/Templates'
import Amount from '../../../../components/Common/Amount'
import BudgetCont from '../../../../components/Common/Budgets/BudgetCont'
import RequisitionsList from '../../../../components/Common/Budgets/RequisitionsList'
import DocumentsCont from '../../../../components/Common/Documents/DocumentsCont'
import EmailCont from '../../../../components/Common/Email/EmailCont'
import InvoiceModalCont from '../../../../components/Common/InvoiceModal/InvoiceModalCont'
import Tracking from '../../../../components/Common/Tracking'
import DeliveryOrderList from '../../../../components/Purchasing/DeliveryOrder/DeliveryOrderList'
import OrderList from '../../../../components/Purchasing/Order/OrderList'
import PaymentPlanCont from '../../../../components/Purchasing/Order/PaymentsPlan/PaymentPlanCont'
import ReadyToOrderCont from '../../../../components/Purchasing/Order/ReadyToOrderCont'
import PaymentTermsCont from '../../../../components/Purchasing/VendorQuotes/PaymentsTerms/PaymentTermsCont'
import InvoicesCont from '../../../../components/Sales/Invoices/InvoicesCont'
import RefreshButton from '../../../../elements/Buttons/RefreshButton'
import CustomSpin from '../../../../elements/CustomSpin'
import withSpinning from '../../../../elements/HOC/withSpinning'
import useFetchList from '../../../../elements/Hooks/useFetchList'
import useFetchURL from '../../../../elements/Hooks/useFetchURL'
import useListCompanyFilter from '../../../../elements/Hooks/useListCompanyFilter'
import useModalShow from '../../../../elements/Hooks/useModalShow'
import useSubmit from '../../../../elements/Hooks/useSubmit'
import useTitle from '../../../../elements/Hooks/useTitle'
import IconText from '../../../../elements/IconText'
import Status from '../../../../elements/Status'
import _, { get, isEmpty, round, sum } from 'lodash'
import Authentication from '../../../../modules/Authentication'
import { idMaker, numVal, strVal } from '../../../../modules/Utils'
import moment from 'moment'

import React, { Fragment, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { streamUrl } from '../../../../variables'
import FormSectionTitle from '../../../../elements/FormSectionTitle'
import LinkHeader from '../../../../elements/LinkHeader'
import { moneyInline } from '../../../../modules/Utils'
import History from '../../../Common/History'
import style from '../../style.css'
import OrderForm from './OrderForm'
import OrderLineModal from './OrderLineModal'
import OrderLinesList from './OrderLinesList'
import EmailListCont from '../../../Main/Emails/EmailCont'
import TimelineFeedCont from '../../../Common/TimelineFeed/TimelineFeedCont'
import TaskSystemList from '../../../Operations/TaskSystem/List'


const api = new OrdersApi()
const { TabPane } = Tabs
const auth = new Authentication()

const templateApi = new Templates()
const emailApi = new Email()

const InvoiceContWithLoading = withSpinning(InvoicesCont)
const ids = idMaker()

function AddOrder(props) {
  const {
    type,
    submitting,
    fetching,
    ServicesSelectCmp,
    submit,
    fetch,
    update,
    formRef,
    actions,
    order,
    handleOps,
    lines,
  } = props

  const [submittingTemplate, submitTemplate] = useSubmit(templateApi.read, true)
  const [submittingOrderTemplate, submitOrderTemplate] = useSubmit(emailApi.salesOrderTemplate, true)
  const [submittingQuoteFiles, submitSalesFiles] = useSubmit(api.files, true)

  const [emailTemplate, setEmailTemplate] = useState('')
  const [emailDetails, setEmailDetails] = useState('')
  const [emailFiles, setEmailFiles] = useState([])
  const [emailLines, setEmailLines] = useState([])

  const { visible: visibleEmail, onShow: onShowEmail, onCancel: onCancelEmail } = useModalShow(async () => {
    let hide = message.loading('Fetching Email Template ...', 0)

    let formattedLines = lines.map((l) => {
      return {
        ...l,
        rate: moneyInline(numVal(l, 'rate')),
        amount: {
          ...l.amount,
          net: moneyInline(numVal(l, 'amount.net')),
        },
      }
    })

    formattedLines.sort((a, b) => a.no - b.no)
    console.log('formattedLines', formattedLines, lines)

    const company = get(order, 'company._id', '').replace('members/', '')
    const quoteTemplate = await submitTemplate(company, 'salesOrder')
    const emailDetails = get(quoteTemplate, 'email') || {}
    const data = await submitOrderTemplate({
      receiver: get(order, 'clientRep.fn'),
      companyRep: get(order, 'companyRep.fn'),
      company: get(order, 'company.fn'),
      address: get(order, 'company.address.label'),
      phone: get(order, 'company.phone.label'),
      url: get(order, 'url'),
      code: get(order, 'code'),
      clientRef: get(order, 'cpo.no'),
      lines: formattedLines,
      ...emailDetails,
    })

    const filesList = await submitSalesFiles([order._id])
    setEmailFiles(filesList)
    const filesMapped = filesList.map((f) => f.uuid)
    setEmailTemplate(data.html)
    console.log({ order })
    setEmailDetails({
      to: get(order, 'clientRep.email.label'),
      cc: get(order, 'companyRep.email.label'),
      bcc: get(emailDetails, 'bcc'),
      from: get(emailDetails, 'from'),
      subject: `[${get(order, 'enquiry.code')} / ${get(order, 'code')}] ${get(emailDetails, 'subject')}`,
      attachments: filesMapped,
    })

    setEmailLines([order])
    hide()
  })

  const [submittingDeliveryOrder, createDeliveryOrderFunc] = useSubmit(api.createDeliveryOrder)

  async function submitQuote() {
    let hide = message.loading('', 0)
    console.log({ order })
    const submitted = await createDeliveryOrderFunc(_.pick(order, ['_key', '_id']))
    if (submitted)
      props.history.push({
        pathname: `/clients/orders/${submitted._key}/update`,
      })
    hide()
  }

  //console.log(100000350.77, moneyInline(100000350.77))
  useTitle(type === 'new' ? `Create New Order` : `${order.code} Order`)
  const isUpdatable = actions.find((a) => a.key === 'update') || false
  const Operations = ({ order, ...rest }) => {
    const ops = actions
      .filter((a) => a.key !== 'update')
      .map((a) => (
        <span>
          <Popconfirm
            placement="left"
            title={`Are you sure to ${a.value}?`}
            onConfirm={() => handleOps(a.key, order)}
            okText="Yes"
            cancelText="No">
            <a>{a.value}</a>
          </Popconfirm>
        </span>
      ))
    order.status !== 'Approved' &&
      ops.push(
        <a target={'_blank'} href={`${streamUrl}pdf/${order._id}?access_token=${auth.getAccessToken()}`}>
          <IconText text={'PDF preview'} type={'file-pdf'} />
        </a>
      )
    order.status === 'Approved' &&
      ops.push(
        <a onClick={onShowEmail}>
          <IconText text={'Email Issuance'} type={'mail'} />
        </a>
      )

    {
      order.status === 'Approved' &&
        ops.push(
          <span>
            <Popconfirm
              placement="left"
              title={`Are you sure to Create Delivery Order?`}
              onConfirm={submitQuote}
              okText="Yes"
              cancelText="No">
              <a>
                <IconText text={'Create Delivery Order'} type={'shopping-cart'} />
              </a>
            </Popconfirm>
          </span>
        )
    }

    return (
      <div {...rest}>
        {ops.length > 0 ? ops.reduce((prev, curr) => [prev, <span className="ant-divider" />, curr]) : []}
      </div>
    )
  }

  const SubmitButton = () =>
    (isUpdatable || type !== 'edit') && (
      <Button
        style={{ float: 'right', marginBottom: 10 }}
        loading={submitting}
        type="primary"
        onClick={type !== 'edit' ? submit : update}>
        {type === 'edit' ? 'Apply Changes' : 'Submit'}
      </Button>
    )

  const { list: reqs, fetching: fetchingReqs, fetch: fetchReqs } = useFetchList(
    () => api.reqs(order._key),
    [order._key],
    isEmpty(order._key)
  )
  const { list: listTasks, fetching: fetchingTasks, fetch: fetchTasks } = useFetchList(
    () => EnquiriesApi.tasks(get(order, 'enquiry._id').replace('activities/','')),
    [get(order, 'enquiry._id')],
    isEmpty(get(order, 'enquiry._id'))
  )
  const { list: listDelivery, fetching: fetchingDelivery, fetch: fetchDelivery } = useFetchList(
    () => DeliveryOrderApi.list('*', `sales=${order._key}`),
    [order._key],
    isEmpty(order._key)
  )

  const { list: cachedListOrders, fetching: fetchingOrders, fetch: fetchOrders } = useFetchList(
    () => PurchaseOrdersApi.listFromSales(order._key),
    [order._key],
    isEmpty(order._key)
  )

  const { list: listOrders, company: companyOrder, onChangeCompany: onChangeCompanyOrder } = useListCompanyFilter(
    cachedListOrders,
    fetchingOrders
  )

  const { data: tracking, fetching: fetchingTracking } = useFetchURL(
    `foxxapi/tracking?select=*&sales=${order._key}&lines=true`,
    [order._key],
    isEmpty(order._key)
  )

  const listTrackingLine = get(tracking[0], 'lines', []).sort((a, b) => moment(b.date).diff(moment(a.date)))[0]

  return (
    <CustomSpin spinning={fetching}>
      <LinkHeader
        title={'Sales Order'}
        link={{
          pathname: `/clients/enquiries/${_.get(order, 'enquiry._id', '').replace('activities/', '')}/update`,
        }}
        code={_.get(order, 'enquiry.code')}
        name={_.get(order, 'enquiry.title')}
        visible={!_.isEmpty(_.get(order, 'enquiry'))}
      />
      <Card>
        <Row className={style.pageHeader}>
          <Breadcrumb>
            <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
            <Breadcrumb.Item>Sales</Breadcrumb.Item>
            <Breadcrumb.Item href={`#/clients/orders/`}>Sales Orders</Breadcrumb.Item>
            <Breadcrumb.Item>New Order</Breadcrumb.Item>
          </Breadcrumb>
          {type === 'new' && <h2 className={style.title}>New Sales Order</h2>}
          {type === 'edit' && (
            <Fragment>
              <Col span={13}>
                <h3 className={style.title}>
                  <h2 className={'icon-text-header'}>
                    <Icon
                      type="barcode"
                      style={{
                        marginRight: '5px',
                        color: '#08c',
                      }}
                    />
                    <Tooltip title="Order Code">{strVal(order, 'code')}</Tooltip>
                  </h2>
                  <Status value={strVal(order, 'status')} />
                  <Operations style={{ marginTop: '10px' }} order={order} status={strVal(order, 'status')} />
                </h3>
              </Col>
              <Col span={5}>
                <Amount
                  data={[
                    { name: 'SUB-TOTAL', amount: numVal(order, 'subTotal.net') },
                    { name: 'TAX', amount: numVal(order, 'subTotal.tax') },
                    { name: 'TOTAL', amount: numVal(order, 'subTotal.gross') },
                  ]}
                  currency={order.currency}
                />
              </Col>
              {get(tracking, '[0]trackingNumber') && (
                <Col span={5}>
                  <Tracking
                    id={get(tracking, '[0]_key')}
                    trackingNumber={get(tracking, '[0]trackingNumber')}
                    data={[
                      { name: 'Tracking Number', value: get(tracking, '[0]trackingNumber') },
                      {
                        name: 'Created',
                        value: moment(get(tracking, '[0]date')).format('YYYY-MM-DD'),
                      },
                      {
                        name: 'Last Location',
                        value: listTrackingLine && listTrackingLine.location,
                      },
                      {
                        name: 'Last Update',
                        value: listTrackingLine && moment(listTrackingLine.date).format('YYYY-MM-DD HH:mm:ss'),
                      },
                    ]}
                  />
                </Col>
              )}
              <RefreshButton onClick={fetch} />
            </Fragment>
          )}

          {type === 'new' && (
            <>
              <p className={style.paragraph}>Create a new Sales Order</p>
            </>
          )}
        </Row>
        <Row style={{ margin: 10, width: '50%' }}>
          {round(sum(props.lines.map((d) => numVal(d, 'unit'))), 2) ===
            round(sum(props.lines.map((d) => numVal(d, 'invoiced'))), 2) &&
            round(sum(props.lines.map((d) => numVal(d, 'unit'))), 2) ===
              round(sum(props.lines.map((d) => numVal(d, 'invoiced'))), 2) &&
            type !== 'new' && <Alert type="success" message={'This Order has been fully invoiced.'} />}
        </Row>
      </Card>
      <EmailCont
        key={ids.next().value}
        visible={visibleEmail}
        onCancel={onCancelEmail}
        template={emailTemplate}
        email={emailDetails}
        files={emailFiles}
        lines={emailLines}
      />
      <Card className={style.contentCard}>
        <Tabs defaultActiveKey={get(props, 'location.hash') || '#details'} onChange={(key) => props.history.push(key)}>
          <TabPane
            tab={
              <span>
                <Icon type="info-circle" />
                Details
              </span>
            }
            key="#details">
            <Row>
              <SubmitButton />
            </Row>
            <OrderLineModal ServicesSelectCmp={ServicesSelectCmp} isUpdatable={isUpdatable} {...props} />
            <OrderForm ref={formRef} loading={fetching} {...props} />
            <FormSectionTitle title={'ORDER LINES'} />
            <InvoiceModalCont key={ids.next().value} orderType={order.orderType} {...props} />
            <OrderLinesList disabled={type !== 'edit'} {...props} />
            <br />
            <Row>
              <SubmitButton />
            </Row>
          </TabPane>
          <TabPane tab={'Tasks & Notes'} key="#tasks-notes">
            <Tabs defaultActiveKey="1">
              <TabPane tab="Notes" key="1">
                <TimelineFeedCont {...{ owner: get(order, 'enquiry._id'), hideNotification: true }} />
              </TabPane>
              <TabPane tab="Tasks" key="2">
                <TaskSystemList
                  fetching={fetchingTasks}
                  fetch={fetchTasks}
                  list={listTasks}
                  hideCompany={true}
                  enquiry={order.enquiry}
                />
              </TabPane>
            </Tabs>
          </TabPane>
          <TabPane
            disabled={type !== 'edit'}
            tab={
              <span>
                <Icon type="ordered-list" /> Client Payment Dates
              </span>
            }
            key="#payment">
            <PaymentPlanCont owner={order} isUpdatable={true} />
          </TabPane>
          <TabPane
            disabled={type !== 'edit'}
            tab={
              <span>
                <Icon type="ordered-list" /> Client Payment Terms
              </span>
            }
            key="#payment-terms">
            <PaymentTermsCont owner={order} isUpdatable={isUpdatable} />
          </TabPane>
          <TabPane
            disabled={type !== 'edit'}
            tab={
              <span>
                <Icon type="credit-card" />
                Budget
              </span>
            }
            key="#budgets">
            <BudgetCont loading={fetching} owner={order} />
          </TabPane>
          <TabPane
            disabled={type !== 'edit'}
            tab={
              <span>
                <Icon type="file-text" />
                Requisition
              </span>
            }
            key="#requisition">
            <RequisitionsList
              reqs={reqs}
              fetchingReqs={fetchingReqs}
              fetchReqs={fetchReqs}
              hideCompany={true}
              saleOrderID={order._id}
            />
          </TabPane>

          <TabPane
            disabled={type !== 'edit'}
            tab={
              <span>
                <Icon type="file-text" />
                Ready To Order
              </span>
            }
            key="#readyToOrder">
            <ReadyToOrderCont requisitionID={reqs.map((r) => r._key).join('||')} />
          </TabPane>

          <TabPane
            disabled={type !== 'edit'}
            tab={
              <span>
                <Icon type="file-text" />
                Delivery Order
              </span>
            }
            key="#delivery">
            <DeliveryOrderList
              {...{
                list: listDelivery,
                fetching: fetchingDelivery,
                fetch: fetchDelivery,
                hideCompany: true,
                hideCreate: true,
              }}
            />
          </TabPane>

          <TabPane
            disabled={type !== 'edit'}
            tab={
              <span>
                <Icon type="file-text" />
                Vendor Order
              </span>
            }
            key="#vendor">
            <OrderList
              {...{
                listOrders,
                fetchingOrders,
                fetchOrders,
                companyOrder,
                onChangeCompanyOrder,
                hideCompany: true,
              }}
            />
          </TabPane>

          <TabPane
            disabled={type !== 'edit'}
            tab={
              <span>
                <Icon type="file-text" />
                Invoices
              </span>
            }
            key="#invoices">
            <InvoiceContWithLoading
              fetching={fetching}
              type={'list'}
              contract={order.contract}
              order={order}
              show={{ companyFilter: false }}
            />
          </TabPane>
          <TabPane
            disabled={type !== 'edit'}
            tab={
              <span>
                <Icon type="copy" />
                History
              </span>
            }
            key="#history">
            <History loading={fetching} owner={order} />
          </TabPane>
          <TabPane tab="Email" key="#email">
          <EmailListCont owner={order._id} />
        </TabPane>
          <TabPane
            disabled={type !== 'edit'}
            tab={
              <span>
                <Icon type="folder-open" />
                Documents
              </span>
            }
            key="#docs">
            <DocumentsCont category={false} email={true} owner={order} />
          </TabPane>
        </Tabs>
      </Card>
    </CustomSpin>
  )
}

AddOrder.propTypes = {}
AddOrder.defaultProps = {}

export default withRouter(AddOrder)
